import { useTranslation } from 'react-i18next';
import ProductCard from "../../components/productCard";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../components/ui/avatar";
import useFruitStore from "../../store/fruits";
import { useEffect } from 'react';
import { scrollToTop } from '../../lib/utils';

const ProducteurDetails = () => {
  const { t, i18n } = useTranslation();
  const { filteredFruits } = useFruitStore();

  useEffect(() => {
    scrollToTop()
  }, [])

  return (
    <div className="flex flex-col gap-6 pt-10 px-8">
      <h1 className="text-[27px] font-normal">{t('producer.detailsTitle')}</h1>
      <div className="flex gap-16 items-center text-grey">
        <Avatar className="w-[114px] h-[114px]">
          <AvatarImage src="../assets/female-09.png" alt="@shadcn" />
          <AvatarFallback>CN</AvatarFallback>
        </Avatar>
        <div className="flex flex-col gap-1 text-[12px] font-normal text-[rgba(0, 0, 0, 0.73)]">
          <span>{t('producer.name')}: Olivier didier</span>
          <span>{t('producer.address')}: Rue Martin Tabi Essomba</span>
          <span>Yaoundé-Cameroun, Centre BP345</span>
          <span>{t('producer.activityYears')}: 10 {t('producer.years')}</span>
        </div>
      </div>
      <h2 className="text-[20px] font-normal">{t('producer.offersTitle')}</h2>
      <div className="flex-grow flex flex-wrap gap-y-4 gap-x-6 max-h-full overflow-scroll">
        {filteredFruits.map((product: any, index) => {
          return (
            <ProductCard
              key={index}
              image={product.image_url}
              category_name={product.category_name}
              uml={product.uml}
              title={i18n.language === "fr" ? product.product_name : product.product_name_en}
              sub_category_name={product.sub_category_name}
              quality={product.minimum_quantity}
              price={product.price}
              stock={product.stock_id}
              quantity={product.quantity}
              seller={product.sale_name}
              productId={product.product_id}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProducteurDetails;